export default __webpack_public_path__ + "static/media/camion-dumper.4aef281a.png";